const ADD_ADDRESS = "Tambahkan alamat";
const EDIT_ADDRESS = "Ubah alamat";
const NOT_APPLICABLE = "Atur titik lokasi untuk metode ini.";
const NOT_APPLICABLE_SUBTEXT = "Tidak tersedia";
const FREE = "Gratis"
const INSTRUCTION_MODAL_HEADING = "Estimasi waktu pengiriman";
const INSTRUCTION_MODAL_SUBHEADING =
  "Perkiraan sampai dihitung sejak produk diterima oleh kurir.";
const NO_PINPOINT_LABEL = "Pengiriman kurir:";
const ADDRESS_LABEL_HEADER = "Kurir lainnnya: ";
const ADDRESS_CHEAPEST_PRICE_HEADER = "Pengiriman Standard hanya ";
const ADDRESS_ADDED_TOAST_MESSAGE =
  "Pastikan alamat terisi dengan benar supaya pesanan Anda sampai di tujuan yang tepat.";
const ADDRESS_ADDED_SUCCESS_TOAST = "Alamat baru berhasil ditambahkan.";
const PHONE_VALIDATION_TEXT_CHAR_LIMIT = "Minimum 8 angka.";
const EMPTY_TEXT_VALIDATION = "Wajib diisi.";
const PHONE_NUMBER_VALIDATION_ISNUMBER_TEXT = "Harus berupa angka.";
const PINPOINT_HEADER = "Masukkan titik lokasi";
const REGULER = "Reguler";
const EKSPRES = "Ekspres";
const INSTANT = "Instant";
const SAME_DAY = "SameDay";

const INSTANT_DESC = "4 - 6 jam";
const SAME_DAY_DESC = "6 - 8 jam";
const JAKARTA = "Jakarta";

const selectedEmail = document.getElementById("email");
const customerEmail = selectedEmail.getAttribute("data-customer-email");

const customerId = document.getElementById("customerId");
const customerIdData = customerId.getAttribute("data-customer-id");

const productPrice = document.getElementById("productPrice");
const productPriceData = productPrice.getAttribute("data-product-price");

const productWeight = document.getElementById("productWeight");
const productWeightData = productWeight.getAttribute("data-product-weight");

const productSku = document.getElementById("productSku");
const productSkuData = productSku.getAttribute("data-product-sku");

const loggedIn = document.getElementById("isLoggedIn");
const loggedInData = loggedIn.getAttribute("data-customer-logged");

const preOrderTag = document.getElementById("preorder-tag");
const preOrderTagData = preOrderTag?.getAttribute("data-preorder-tag");

const pinPointBanner = document.querySelector(".setPinPoint-banner");
const addressDiv = document.querySelector(".shipping-send-to");
const notCoveredBanner = document.querySelector(".notCovered-banner");
const customSelectArea = document.querySelector(".custom-select-area");
let customSelectOptionsContainer = document.querySelector(
  ".area-select-options"
);
const areaField = document.querySelector(".area-select");
const nameField = document.getElementById("name-select");
const phoneField = document.getElementById("phone-select");
const areaFullAddressField = document.getElementById("alamat-select");
const notloggedInOpener = document.getElementById("notLoggedIn-btn");
const instructionModalBtn = document.getElementById("instructionModal-btn");
const pinPointAddress = document.querySelector(".pinPoint-address");
const viewMobileDeliveries = document.querySelector(
  ".view_all_deliveries-mobile-btn"
);
const viewMobileDeliveriesText = document.querySelector(
  ".view_all_deliveries-mobile-text"
);
const addressTitle = document.querySelector(".delivery_time-text-title");
const labelDiv = document.querySelector(".applicable-shipping-methods");
const labelDivMobile = document.querySelector(
  ".applicable-shipping-methods-mobile"
);
const mapSubmitButton = document.querySelector(
  ".customer-location__select-address__container"
);
const domain = document.getElementById("domain");
const domainData = domain.getAttribute("data-domain");
const editLocation = document.getElementById("atur");
mapSubmitButton.style.pointerEvents = "none";
const mapTitle = document.getElementById("mapTitle");
const addressTitleText = document.getElementById("addressTitle");
let instructionsData = "";
let currentLocationData = "";
let notCovered = false;
let savedAddressData = {};
let savedMoreAddressData = {};
let savedAddressDataDiv = "";
let splittedCode = "";
let subDistrictsList = [];
let addAddressData = {};
let editAddressData = {};
let editableId = "";
let editableUbah = false;
let editableUbahId = "";
let editable = false;
let keyMessage = "";
let apiFailed = false;
let addressProvince = "";
let isUserSelectAddress = false;
let preOrderData = getPreOrderData();
(addressTitleText.innerText = ADD_ADDRESS), (mapTitle.innerText = ADD_ADDRESS);

const DEFAULT_STATE = "Indonesia";
const DETAIL_AVAILABLE_LIST = [
  "street_address",
  "premise",
  "sub_premise",
  "point_of_interest",
];

const DEFAULT_MAP_OPTIONS = {
  minZoom: 1,
  streetViewControl: false,
  scrollwheel: true,
  disableDoubleClickZoom: false,
  draggable: true,
  panControl: false,
  mapTypeControl: false,
  scaleControl: false,
  fullscreenControl: false,
};

let selectedAddress = "";
let selectedAddressDistrict = "";
let selectedLatLong = {};

const mapElement = document.getElementById("mapCanvas");
let map = "";
let latitude = -6.192443;
let longitude = 106.822271;
let fullAddress = "";
let addressName = "";
let state = "";
let postalCode = "";
let subdistrict = "";
let district = "";
let city = "";
let searchValue = "";
let province = "";
let dropdownValue = [];

function initGoogle() {
  document.querySelector(
    ".customer-location__address-container__location"
  ).style.display = "none";
  const script = document.createElement("script");
  script.src =
    script.src = `https://maps.googleapis.com/maps/api/js?key=${mapSecretKey}&language=in&region=ID&libraries=places&callback=initMap`;
  mapElement.appendChild(script);
}

function initMap() {
  const self = this;
  const google = window.google;
  if (!google) {
    setTimeout(() => {
      self.initMap();
    }, 150);
    return;
  }
  const initPos = {
    lat: latitude,
    lng: longitude,
  };
  const options = {
    zoomControl: false,
    zoom: 18,
    center: new google.maps.LatLng(initPos.lat, initPos.lng),
    ...DEFAULT_MAP_OPTIONS,
  };
  map = new google.maps.Map(mapElement, options);
  map.addListener("center_changed", centerChangedListener);
  map.addListener("dragend", dragEndListener);
  map.addListener("drag", dragListener);
  map.addListener("zoom_changed", zoomChangedListener);

  const inputSearchElement1 = document.querySelector(
    ".customer-location__address-search__input-1"
  );
  inputSearchElement1.addEventListener("keyup", debouncedHandleSearchLocationOnMaps);

  const inputSearchElementloggedOut = document.querySelector(
    ".customer-location__address-search__input-loggedOut"
  );
  inputSearchElementloggedOut.addEventListener(
    "keyup",
    handleSearchLocationLoggedOut
  );

  const inputSearchElement = document.querySelector(
    ".customer-location__address-search__input"
  );
  inputSearchElement.addEventListener("keyup", debouncedHandleSearchLocation);

  checkLocationPermission();
  getCurrentPosition();
  populateDefaultAddress();
}

const debouncedHandleSearchLocation = debounce(handleSearchLocation, 300);
const debouncedHandleSearchLocationOnMaps = debounce(handleSearchLocationOnMaps, 300);
function handleSearchLocationLoggedOut() {
  searchValue = document.querySelector(
    ".customer-location__address-search__input-loggedOut"
  ).value;
  const clearIconInputloggedOut = document.querySelector(
    ".customer-location__address-search__input-loggedOut-clear"
  );
  if (searchValue.length !== 0) {
    clearIconInputloggedOut.style.display = "block";
  } else {
    clearIconInputloggedOut.style.display = "none";
  }
  if (searchValue.length > 3) {
    debouncedHandleSearchLogout();
    const locationBlock = document.querySelector(".location-block");
    locationBlock ? (locationBlock.style.display = "none") : " ";
    const locationBlockMobile = document.querySelector(
      ".location-block-mobile"
    );
    locationBlockMobile ? (locationBlockMobile.style.display = "none") : " ";
    const allowLocationSubtext = document.querySelector(
      ".allow-location-subtext"
    );
    allowLocationSubtext ? (allowLocationSubtext.style.display = "none") : " ";
    const currentLocationDiv = document.querySelector(".current-location");
    currentLocationDiv ? (currentLocationDiv.style.display = "none") : "";
  }
}

function handleSearchLocation() {
  searchValue = document.querySelector(
    ".customer-location__address-search__input"
  ).value;
  const clearIconInput = document.querySelector(
    ".customer-location__address-search__input-clear"
  );
  if (searchValue.length !== 0) {
    clearIconInput.style.display = "block";
  } else {
    clearIconInput.style.display = "none";
  }

  if (searchValue.length > 3) {
    triggerInputEvent();
    document.querySelector(".location-block").style.display = "none";
    const currentLocationDiv = document.querySelector(".current-location");
    currentLocationDiv ? (currentLocationDiv.style.display = "none") : "";
  }
}
function handleSearchLocationOnMaps() {
  searchValue = document.querySelector(
    ".customer-location__address-search__input-1"
  ).value;
  const clearIconInput1 = document.querySelector(
    ".customer-location__address-search__input-1-clear"
  );
  if (searchValue.length !== 0) {
    clearIconInput1.style.display = "block";
  } else {
    clearIconInput1.style.display = "none";
  }

  if (searchValue.length > 3) {
    triggerInputEvent1();
  } else if (searchValue.length) {
    document.querySelector(
      ".customer-location__address-container__location"
    ).style.display = "none";
  }
}

function checkLocationPermission() {
  navigator.geolocation.getCurrentPosition(
    () => {
      const currentLocationDiv = document.querySelector(".current-location");
      currentLocationDiv ? (currentLocationDiv.style.display = "block") : "";
    },
    () => {
      const infoDiv = document.querySelector(".location-block");
      infoDiv ? (infoDiv.style.display = "flex") : "";
      const locationBlockMobile = document.querySelector(
        ".location-block-mobile"
      );
      locationBlockMobile ? (locationBlockMobile.style.display = "flex") : "";
      const allowLocationSubtext = document.querySelector(
        ".allow-location-subtext"
      );
      allowLocationSubtext
        ? (allowLocationSubtext.style.display = "block")
        : "";
      console.error("Not able to get the location");
    }
  );
}

function centerChangedListener() {
  document.getElementsByClassName(
    "customer-location__map-onboarding"
  )[0].style.display = "none";
  setLangLat();
}
function dragEndListener() {
  setLangLat();
  getGeolocationDetail({ lat: latitude, lng: longitude });
  unList1.innerHTML = "";
  if (state === DEFAULT_STATE) {
    document.querySelector(
      ".customer-location__address-container__location"
    ).style.display = "flex";
    document.querySelector(
      ".customer-location__address-container__location-title"
    ).innerHTML = addressName;
    document.querySelector(
      ".customer-location__address-container__location-description"
    ).innerHTML = fullAddress;
  } else {
    document.querySelector(
      ".customer-location__address-container__location"
    ).style.display = "none";
  }
  getGeolocationDetail({ lat: latitude, lng: longitude }, false, null, "save");
}
function dragListener() { }
function zoomChangedListener() {
  // set loading - true
  setLangLat();
  getGeolocationDetail({ lat: latitude, lng: longitude });
}

function setLangLat() {
  const place = map.getCenter();
  latitude = place.lat();
  longitude = place.lng();
}

async function getGeolocationDetail(position, fromList, id, event, currentPosition, cardAddress, editData) {
  try {
    if (typeof position === "string") {
      const placesService = new window.google.maps.places.PlacesService(map);
      const place = await new Promise((resolve, reject) => {
        placesService.getDetails({ placeId: position }, (place, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            resolve(place);
          } else {
            reject(`PlacesService failed: ${status}`);
          }
        });
      });

      const latLng = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };

      await getGeocode(latLng, fromList, id, event, currentPosition, cardAddress, editData);
    } else {
      await getGeocode(position, fromList, id, event, currentPosition, cardAddress, editData);
    }
  } catch (error) {
    console.error("Error in getGeolocationDetail:", error);
  }
}
async function getGeocode(latLong,fromList,id,event,currentPosition,cardAddress,editData) {
  const geocoder = new window.google.maps.Geocoder();
  geocoder.geocode({ location: latLong }, (results) => {
    handleSuccessGetGeolocationDetail(results,latLong,fromList,id,event,currentPosition,cardAddress,editData)
  }
  );
}

function handleSuccessGetGeolocationDetail(results, position, fromList, id, event, currentPosition, cardAddress, editData) {
  // set loading - false
  if (results === null || results.length === 0) {
    state = "";
    postalCode = "";
    subdistrict = "";
    district = "";
    longitude = 0;
    latitude = 0;
    city = "";
    return;
  }
  const resultDetail = getComponentDetail(results);
  setAddressField(resultDetail, position);
  const locationMain = document.querySelector(".current-location-main");
  locationMain ? (locationMain.innerText = district) : "";
  const locationSub = document.querySelector(".current-location-sub");
  locationSub ? (locationSub.innerText = fullAddress) : "";
  if (fromList) {
    const list = document.getElementById(id.listId);
    list ? (list.innerText = fullAddress) : "";
    if (id.clickedId) {
      if (state === DEFAULT_STATE) {
        let clickedElement = document.getElementById(id.clickedId);
        unList1.innerHTML = "";
        mapSubmitButton.style.pointerEvents = "unset";
        unList1.appendChild(clickedElement);
      } else {
        unList1.innerHTML = "";
        mapSubmitButton.style.pointerEvents = "none";
      }
    }
  }
  selectedLatLong = position;
  const addressDiv = document.querySelector(".shipping-send-to");
  if (event === "click") {
    selectedAddress = fullAddress;
    selectedAddressDistrict = district;
    addressDiv ? (addressDiv.innerText = "Kirim ke: " + selectedAddress) : "";
    isUserSelectAddress = true
    sendLatLong(position);
  }

  if (state === DEFAULT_STATE) {
    savedAddressData = {
      fullAddress,
      addressName,
      district,
      province,
      latLong: { latitude, longitude },
      state,
      city,
      postalCode,
    };
  } else {
    savedAddressData = {};
  }

  if (event === "save") {
    if (state === DEFAULT_STATE) {
      mapSubmitButton.style.pointerEvents = "unset";
    }
  } else if (event === "edit") {
    if (state === DEFAULT_STATE) {
      populateAddressField(editData.name, editData.phone);
    }
  } else if (event === "saveListData") {
    if (state === DEFAULT_STATE) {
      closeModal();
      const openModal = document.getElementById("address-submit-list");
      if (openModal) {
        const buttonInsideOpener = openModal.querySelector("button");
        if (buttonInsideOpener) {
          buttonInsideOpener.click();
          populateAddressField();
        }
      }
      const unList = document.getElementById("UnList");
      const input = document.querySelector(
        ".customer-location__address-search__input"
      );
      unList.innerHTML = "";
      input.value = "";
      clearIconInput.style.display = "none";
    }
  } else if (event === "saveListDataNotLoggedIn") {
    if (state === DEFAULT_STATE) {
      closeModal();
      const openModalNotLoggedIn = document.getElementById(
        "address-submit-list-notLoggedIn"
      );
      if (openModalNotLoggedIn) {
        const buttonInsideOpenerNotLoggedIn =
          openModalNotLoggedIn.querySelector("button");
        if (buttonInsideOpenerNotLoggedIn) {
          buttonInsideOpenerNotLoggedIn.click();
          populateAddressField();
        }
      }
    }
  }

  if (currentPosition === "currentPosition") {
    selectedAddress = fullAddress;
    selectedAddressDistrict = district;
    addressDiv ? (addressDiv.innerText = "Kirim ke: " + selectedAddress) : "";
    currentLocationData = {
      currentPosition: { latitude: latitude, longitude: longitude },
      currentCity: city,
      currentPostalCode: postalCode,
      currentProvince: province,
      currentDistrict: district,
      currentSubDistrict: subdistrict,
    };
    isUserSelectAddress = true;
    sendLatLong(currentLocationData);
  }
}

function getGeolocationDetailByName(name) {
  const geocoder = new window.google.maps.Geocoder();
  geocoder.geocode({ address: name }, handleSuccessGetGeolocationDetailByName);
}

function closeModal() {
  const allModals = document.querySelectorAll("hello-modal-dialog");
  allModals.forEach((modal) => {
    modal.hide();
  });
}
function handleSuccessGetGeolocationDetailByName(results) {
  // set loading - false
  if (results === null || results.length === 0) {
    state = "";
    postalCode = "";
    subdistrict = "";
    district = "";
    city = "";
    longitude = 0;
    latitude = 0;
    return;
  }
  const result = getComponentDetail(results);
  setCenterMap(result);
  const location = {
    lat: result.geometry.location.lat(),
    lng: result.geometry.location.lng(),
  };
  if (result.address_components.find((i) => i.types[0] === "postal_code")) {
    setAddressField(result, location);
    return;
  }
  getGeolocationDetail(location);
}

function setCenterMap(location) {
  if (location.geometry.viewport) {
    map.fitBounds(location.geometry.viewport);
    return;
  }
  map.setCenter(location.geometry.location);
  map.setZoom(18);
}

function getComponentDetail(results) {
  for (let i = 0; i < results.length; i++) {
    if (
      results[i].address_components.find((i) => i.types[0] === "postal_code")
    ) {
      return results[i];
    }
  }
  return results[0];
}

function setAddressField(address, pos) {
  if (!address.name || address.formatted_address.indexOf(address.name) === 0) {
    fullAddress = address.formatted_address;
  } else {
    fullAddress = `${address.name}, ${address.formatted_address}`;
  }
  addressName = address.name
    ? address.name
    : setComponentField(
      address.address_components.find((i) => i.types[0] === "route")
    );
  state = setComponentField(
    address.address_components.find((i) => i.types[0] === "country")
  );
  postalCode = setComponentField(
    address.address_components.find((i) => i.types[0] === "postal_code")
  );
  subdistrict = setComponentField(
    address.address_components.find(
      (i) => i.types[0] === "administrative_area_level_4"
    )
  );
  city = setComponentField(
    address.address_components.find(
      (i) => i.types[0] === "administrative_area_level_2"
    )
  );
  province = setComponentField(
    address.address_components.find(
      (i) => i.types[0] === "administrative_area_level_1"
    )
  );
  district = filterDistrictPrefix(
    setComponentField(
      address.address_components.find(
        (i) => i.types[0] === "administrative_area_level_3"
      )
    )
  );
  longitude = pos.lng;
  latitude = pos.lat;
}

function setComponentField(value) {
  return value ? value.long_name : "";
}

function filterDistrictPrefix(value) {
  if (!value) return "";
  return value.replace(/Kecamatan |Kec. /g, "");
}

function getCurrentPosition() {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const pos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      map.setCenter(pos);
      map.setZoom(18);
      const currentLocationDiv = document.querySelector(".current-location");
      if (currentLocationDiv) {
        const jsonString = JSON.stringify(pos);
        currentLocationDiv.setAttribute("data-custom-property", jsonString);
      }
    },
    () => {
      getGeolocationDetail({ lat: latitude, lng: longitude });
    },
    { timeout: 10000 }
  );
}

function triggerInputEvent() {
  dropdownValue = [];
  if (!searchValue || searchValue.length < 3) return (dropdownValue = []);
  const sessionToken = new google.maps.places.AutocompleteSessionToken();
  const autocompleteService =
    new window.google.maps.places.AutocompleteService();
  autocompleteService.getPlacePredictions(
    {
      input: searchValue,
      sessionToken
    },
    (predictions) => {
      predictions.map((item) => {
          dropdownValue.push({
            id: item.place_id,
            title: item.structured_formatting.main_text,
            desc: item.description,
            types: item.types,
          });
          if (dropdownValue.length > 0) {
            document.getElementById("UnList").innerHTML = "";
            for (let i = 0; i < dropdownValue.length; i++) {
              let list = 0;
              list = document.getElementById("UnList");
              list.style.padding = 0;
              let parentDiv = document.createElement("div");
              parentDiv.style.cursor = "pointer";
              parentDiv.id = "unlist-" + i;
              parentDiv.setAttribute("data-custom-property", dropdownValue[i].id);
              let div = document.createElement("div");
              div.style.display = "flex";
              div.style.height = "18px";
              div.style.pointerEvents = "none";
              let locImage = document.createElement("div");
              let elem = document.createElement("img");
              elem.setAttribute(
                "src",
                "https://cdn.shopify.com/s/files/1/0738/5245/3172/files/bli-icon-location-light.svg?v=1703564597"
              );
              elem.setAttribute("height", "24");
              elem.setAttribute("width", "24");
              locImage.appendChild(elem);
              let locText = document.createElement("div");
              locText.className = "location-text";
              locText.innerText = "Titik lokasi";
              div.appendChild(locImage);
              div.appendChild(locText);
              let li = document.createElement("li");
              li.innerHTML = null;
              li.innerText = dropdownValue[i].title;
              li.innerText = dropdownValue[i].desc;
              li.id = "unList-list_" + i;
              li.className = "location-list";
              let locTitle = document.createElement("div");
              locTitle.innerText = dropdownValue[i].title;
              locTitle.className = "location-title";
              parentDiv.appendChild(div);
              parentDiv.appendChild(locTitle);
              parentDiv.appendChild(li);
              parentDiv.style.marginBottom = "12px";
              parentDiv.style.paddingBottom = "12px";
              div.style.pointerEvents = "none";
              list.appendChild(parentDiv);
            }
          } else {
            document.querySelector(
              ".customer-location__address-container__location"
            ).style.display = "none";
          }
      });
    }
  );
}

function triggerInputEvent1() {
  dropdownValue = [];
  if (!searchValue || searchValue.length < 3) return (dropdownValue = []);
  const sessionToken = new google.maps.places.AutocompleteSessionToken();
  const autocompleteService =
    new window.google.maps.places.AutocompleteService();
  autocompleteService.getPlacePredictions(
    {
      input: searchValue,
      sessionToken
    },
    (predictions) => {
      predictions.map((item) => {
            dropdownValue.push({
              id: item.place_id,
              title: item.structured_formatting.main_text,
              desc: item.description,
              types: item.types
            });

            if (dropdownValue.length > 0) {
              document.getElementById("UnList1").innerHTML = "";
              for (let i = 0; i < dropdownValue.length; i++) {
                let list = 0;
                list = document.getElementById("UnList1");
                list.style.padding = 0;
                let parentDiv = document.createElement("div");
                parentDiv.style.cursor = "pointer";
                parentDiv.id = "unlist_" + i;
                parentDiv.setAttribute("data-custom-property", dropdownValue[i].id);
                let div = document.createElement("div");
                div.style.display = "flex";
                div.style.height = "18px";
                let locImage = document.createElement("div");
                let elem = document.createElement("img");
                elem.setAttribute(
                  "src",
                  "https://cdn.shopify.com/s/files/1/0738/5245/3172/files/bli-icon-location-light.svg?v=1703564597"
                );
                elem.setAttribute("height", "24");
                elem.setAttribute("width", "24");
                locImage.appendChild(elem);
                let locText = document.createElement("div");
                locText.className = "location-text";
                locText.innerText = "Titik lokasi";
                div.appendChild(locImage);
                div.appendChild(locText);
                let li = document.createElement("li");
                li.innerHTML = null;
                li.innerText = dropdownValue[i].title;
                li.innerText = dropdownValue[i].desc;
                li.id = "unList-list1_" + i;
                li.className = "location-list";
                let locTitle = document.createElement("div");
                locTitle.innerText = dropdownValue[i].title;
                locTitle.className = "location-title";
                parentDiv.appendChild(div);
                parentDiv.appendChild(locTitle);
                parentDiv.appendChild(li);
                parentDiv.style.marginBottom = "12px";
                parentDiv.style.paddingBottom = "12px";
                list.appendChild(parentDiv);
              }
            } else {
              document.querySelector(
                ".customer-location__address-container__location"
              ).style.display = "none";
            }
          }
        );
    }
  );
}
const debouncedHandleSearchLogout = debounce(triggerInputEventloggedOut, 300);
function triggerInputEventloggedOut() {
  dropdownValue = [];
  if (!searchValue || searchValue.length < 3) return (dropdownValue = []);
  const sessionToken = new google.maps.places.AutocompleteSessionToken();
  const autocompleteService =
    new window.google.maps.places.AutocompleteService();
  autocompleteService.getPlacePredictions(
    {
      input: searchValue,
      sessionToken
    },
    (predictions) => {
      predictions.map((item) => {
          dropdownValue.push({
            id: item.place_id,
            title: item.structured_formatting.main_text,
            desc: item.description,
            types: item.types,
          });
          if (dropdownValue.length > 0) {
            document.getElementById("UnListNotLoggedIn").innerHTML = "";
            for (let i = 0; i < dropdownValue.length; i++) {
              let list = 0;
              list = document.getElementById("UnListNotLoggedIn");
              list.style.padding = 0;
              let parentDiv = document.createElement("div");
              parentDiv.style.cursor = "pointer";
              parentDiv.id = "unListNotLoggedIn_" + i;
              parentDiv.setAttribute("data-custom-property-notloggedIn", dropdownValue[i].id)
              let locImage = document.createElement("div");
              let elem = document.createElement("img");
              elem.setAttribute(
                "src",
                "https://cdn.shopify.com/s/files/1/0738/5245/3172/files/bli-icon-location-light.svg?v=1703564597"
              );
              elem.setAttribute("height", "20");
              elem.setAttribute("width", "20");
              locImage.appendChild(elem);
              let li = document.createElement("li");
              li.innerHTML = null;
              li.innerText = dropdownValue[i].title;
              li.innerText = dropdownValue[i].desc;
              li.id = "notloggedInLi_" + i;
              li.className = "location-list-notLoggedIn";
              let locDiv = document.createElement("div");
              locDiv.style.display = "flex";
              locDiv.style.pointerEvents = "none";
              let locTitle = document.createElement("div");
              locTitle.innerText = dropdownValue[i].title;
              locTitle.className = "location-title-notLoggedIn";
              locDiv.appendChild(elem);
              locDiv.appendChild(locTitle);
              parentDiv.appendChild(locDiv);
              parentDiv.appendChild(li);
              parentDiv.className = "location-container-notLoggedIn";
              list.appendChild(parentDiv);
            }
          } else {
            document.querySelector(
              ".customer-location__address-container__location"
            ).style.display = "none";
          }
        });
    }
  );
}

function checkDetailsAvailability(item) {
  closeSearch();
  let detailsAvailable = false;
  for (let i = 0; i < item.types.length; i++) {
    if (DETAIL_AVAILABLE_LIST.includes(item.types[i])) {
      detailsAvailable = true;
    }
  }
  if (detailsAvailable) {
    getPlaceDetail(item);
    return;
  }
  getGeolocationDetailByName(item.desc);
}

function getPlaceDetail(item) {
  const placesService = new window.google.maps.places.PlacesService(this.map);
  placesService.getDetails(
    {
      placeId: item.id,
      fields: [
        "address_component",
        "adr_address",
        "formatted_address",
        "geometry",
        "name",
        "place_id",
        "types",
      ],
    },
    (place) => handleSuccessGetPlace(place, item)
  );
}

function handleSuccessGetPlace(place, item) {
  setCenterMap(place);
  const location = {
    lat: place.geometry.location.lat(),
    lng: place.geometry.location.lng(),
  };
  if (place.address_components.find((i) => i.types[0] === "postal_code")) {
    setAddressField(place, location);
    return;
  }
  getGeolocationDetailByName(item.desc);
}

function closeSearch() {
  searchValue = "";
  dropdownValue = [];
}

const clearIconInput1 = document.querySelector(
  ".customer-location__address-search__input-1-clear"
);
const clearIconInput = document.querySelector(
  ".customer-location__address-search__input-clear"
);
const clearIconInputloggedOut = document.querySelector(
  ".customer-location__address-search__input-loggedOut-clear"
);
clearIconInput1.addEventListener("click", () => {
  const list = document.getElementById("UnList1");
  list.innerHTML = "";
  const input = document.querySelector(
    ".customer-location__address-search__input-1"
  );
  input.value = "";
  clearIconInput1.style.display = "none";
});

clearIconInput.addEventListener("click", () => {
  const list = document.getElementById("UnList");
  list.innerHTML = "";
  const input = document.querySelector(
    ".customer-location__address-search__input"
  );
  input.value = "";
  clearIconInput.style.display = "none";
});

clearIconInputloggedOut.addEventListener("click", () => {
  const list = document.getElementById("UnListNotLoggedIn");
  list.innerHTML = "";
  const input = document.querySelector(
    ".customer-location__address-search__input-loggedOut"
  );
  input.value = "";
  clearIconInputloggedOut.style.display = "none";
});

const unList1 = document.getElementById("UnList1");

unList1.addEventListener("click", async function (event) {
  const clickedElement = event.target
  const customPropertyObject = clickedElement.getAttribute("data-custom-property")
  const placesService = new window.google.maps.places.PlacesService(map);
  const place = await new Promise((resolve, reject) => {
    placesService.getDetails({ placeId: customPropertyObject }, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        resolve(place)
      } else {
        reject(`PlacesService failed: ${status}`)
      }
    })
  })

  const latLng = {
    lat: place.geometry.location.lat(),
    lng: place.geometry.location.lng(),
  }
  map.setCenter(latLng)
  let listId = clickedElement.querySelector(".location-list").id;
  getGeolocationDetail(
    latLng,
    true,
    { listId: listId, clickedId: clickedElement.id },
    "save"
  );
});

const unListNotLoggedIn = document.getElementById("UnListNotLoggedIn");

unListNotLoggedIn.addEventListener("click", function (event) {
  const clickedElement = event.target;
  const customPropertyObject = clickedElement.getAttribute("data-custom-property-notloggedIn")
  if (loggedInData) {
    getGeolocationDetail(customPropertyObject, false, null, "saveListDataNotLoggedIn");
  } else {
    getGeolocationDetail(customPropertyObject, false, null, "click");
    closeModal();
  }
  const input = document.querySelector(
    ".customer-location__address-search__input-loggedOut"
  );
  unListNotLoggedIn.innerHTML = "";
  input.value = "";
  clearIconInputloggedOut.style.display = "none";
});

const unList = document.getElementById("UnList");

unList.addEventListener("click", function (event) {
  const clickedElement = event.target;
  const customPropertyObject = clickedElement.getAttribute("data-custom-property")
  getGeolocationDetail(customPropertyObject, false, null, "saveListData");
  (addressTitleText.innerText = ADD_ADDRESS),
    (mapTitle.innerText = ADD_ADDRESS);
});

function notPinPointAction() {
  const instructionDivShipping = document.querySelector(
    ".shipping-instruction"
  );
  instructionDivShipping.innerHTML = "";
  addressTitle.innerText = NO_PINPOINT_LABEL;
  labelDiv.innerText = "";
  labelDivMobile.innerHTML = "";
  viewMobileDeliveriesText.style.display = "block";
  viewMobileDeliveries.style.display = "none";
  addressDiv ? (addressDiv.innerText = "Kirim ke: " + selectedAddress) : "";
  const instructionDiv = document.getElementById("instruction");
  instructionDiv.innerHTML = "";
  pinPointBannerPdp.style.display = "block";
  shippingMethods.style.display = "block";
  shippingMethodsNotSet.style.display = "none";
  addressSet.style.display = "block";
  addressNotSet.style.display = "none";
  subAddress.innerHTML = selectedAddress;
  mainAddress.innerHTML = "";
  pinPointBannerPdp.style.display = "block";
  notCoveredBanner.style.display = "none";
  pinPointBanner.style.display = "block";
}

const savedCards = document.getElementById("cards");

if (savedCards) {
  savedCards.addEventListener("click", function (event) {
    editable = false;
    (addressTitleText.innerText = ADD_ADDRESS),
      (mapTitle.innerText = ADD_ADDRESS);
    const clickedElement = event.target;
    const customPropertyObject = JSON.parse(
      clickedElement.getAttribute("data-custom-position")
    );
    const customPropertyId = JSON.parse(
      clickedElement.getAttribute("data-custom-card-id")
    );
    const cardHeaderElement = clickedElement.querySelector(".card-address");
    if (customPropertyObject?.lat !== 0.0) {
      shippingMethods.style.display = "block";
      pinPointBannerPdp.style.display = "none";
      pinPointBanner.style.display = "none";
      getGeolocationDetail(
        customPropertyObject,
        false,
        null,
        "click",
        "",
        fullAddress
      );
    } else {
      selectedAddress = cardHeaderElement.textContent;
      selectedAddressDistrict = "";
      editableId = customPropertyId;
      (addressTitleText.innerText = EDIT_ADDRESS),
        (mapTitle.innerText = EDIT_ADDRESS);
      notPinPointAction();
      selectedLatLong = {}
      postalCode = clickedElement.getAttribute("data-custom-zip")
      subdistrict = clickedElement.getAttribute("data-custom-address2").split(',')[0]
      district = clickedElement.getAttribute("data-custom-address2").split(',')[1]
      province = clickedElement.getAttribute("data-custom-province")
      isUserSelectAddress = true
      sendLatLong(null)
    }
    if (clickedElement.className !== "seeMore-container") {
      closeModal();
    }
  });
}

const savedAddressMore = document.getElementById("address-grp");

if (savedAddressMore) {
  savedAddressMore.addEventListener("click", function (event) {
    const clickedElement = event.target;
    const customPropertyObject = JSON.parse(
      clickedElement.getAttribute("data-custom-more-address-position")
    );
    savedMoreAddressData = customPropertyObject;
    savedAddressDataDiv = clickedElement;
  });
}

const addressMoreModalSubmitButton = document.querySelector(
  ".selectAddress-addGrp-button"
);

addressMoreModalSubmitButton.addEventListener("click", () => {
  editable = false;
  (addressTitleText.innerText = ADD_ADDRESS),
    (mapTitle.innerText = ADD_ADDRESS);
  if (Object.keys(savedMoreAddressData).length === 0) {
    const firstAddress = document.getElementById("address-grp_0");
    const firstAddressData = JSON.parse(
      firstAddress.getAttribute("data-custom-more-address-position")
    );
    savedMoreAddressData = firstAddressData;
    savedAddressDataDiv = firstAddress;
  }
  const customPropertyId = JSON.parse(
    savedAddressDataDiv.getAttribute("data-custom-grp-id")
  );
  const cardGrpHeaderElement = savedAddressDataDiv.querySelector(
    ".address-grp-main_address"
  );
  if (savedMoreAddressData.lat !== 0.0) {
    shippingMethods.style.display = "block";
    pinPointBannerPdp.style.display = "none";
    pinPointBanner.style.display = "none";
    getGeolocationDetail(
      savedMoreAddressData,
      false,
      null,
      "click",
      "",
      fullAddress
    );
    selectedAddress = fullAddress;
    closeModal();
  } else {
    selectedAddress = cardGrpHeaderElement.textContent;
    selectedAddressDistrict = "";
    editableId = customPropertyId;
    (addressTitleText.innerText = EDIT_ADDRESS),
      (mapTitle.innerText = EDIT_ADDRESS);
    notPinPointAction();
    closeModal();
  }
  let searchInput = document.querySelector(".saved__address-search__input");
  searchInput.value = "";
  const inputEvent = new Event("input", { bubbles: true });
  searchInput.dispatchEvent(inputEvent);
});

const currentLocationDiv = document.querySelector(".current-location");
if (currentLocationDiv) {
  currentLocationDiv.addEventListener("click", function (event) {
    const clickedElement = event.target;
    const customPropertyObject = JSON.parse(
      clickedElement.getAttribute("data-custom-property")
    );
    getGeolocationDetail(
      customPropertyObject,
      false,
      null,
      null,
      "currentPosition"
    );
    closeModal();
  });
}

const addressSet = document.querySelector(".has-address-set");
const addressNotSet = document.querySelector(".has-address-notSet");
const mainAddress = document.querySelector(".main-address");
const subAddress = document.querySelector(".sub-address");
const shippingMethods = document.querySelector(".shipping-methods");
const shippingMethodsNotSet = document.querySelector(
  ".shipping-methods-no-address"
);
const pinPointBannerPdp = document.querySelector(".setPinPoint-banner-pdp");
function updateAddressDisplay() {
  if (instructionsData) {
    mainAddress.innerHTML = selectedAddressDistrict;
    subAddress.innerHTML = selectedAddress;
    addressSet.style.display = "block";
    addressNotSet.style.display = "none";
    shippingMethods.style.display = "block";
    shippingMethodsNotSet.style.display = "none";
  } else {
    addressNotSet.style.display = "block";
    addressSet.style.display = "none";
    shippingMethodsNotSet.style.display = "block";
    shippingMethods.style.display = "none";
  }
}

function populateDefaultAddress() {
  editable = false;
  (addressTitleText.innerText = ADD_ADDRESS),
    (mapTitle.innerText = ADD_ADDRESS);
  const selectedAddressElement = document.getElementById(
    "selected-address-data"
  );
  const selectedAddress1 = selectedAddressElement.getAttribute(
    "data-selected-address"
  );

  const selectedAddressElementId = document.getElementById(
    "selected-address-id"
  );
  const selectedAddressIdData =
    selectedAddressElementId.getAttribute("data-selected-id");

  const addressDetails = selectedAddress1.split(";");
  const addressLine1 = addressDetails[0];
  const addressLine2 = addressDetails[1];
  const addressDiv = document.querySelector(".shipping-send-to");
  if (loggedInData && (addressLine1 || addressLine2)) {
    selectedAddress = addressLine2;
    selectedAddressDistrict = addressLine1;
    addressDiv ? (addressDiv.innerText = "Kirim Ke: " + selectedAddress) : "";
    const defaultlatLong = document.getElementById("customer-lat-long");
    const defaultlatLongData = defaultlatLong.getAttribute(
      "data-customer-position"
    );
    if (defaultlatLongData.length > 2) {
      pinPointBanner.style.display = "none";
      pinPointBannerPdp.style.display = "none";
      viewMobileDeliveries.style.display = "flex";
      viewMobileDeliveriesText.style.display = "none";
      const defaultlatLongString = defaultlatLongData.toString().split(",");
      getGeolocationDetail(
        {
          lat: parseFloat(defaultlatLongString[0]),
          lng: parseFloat(defaultlatLongString[1]),
        },
        false,
        null,
        "click"
      );
    } else {
      addressTitle.innerText = NO_PINPOINT_LABEL;
      viewMobileDeliveriesText.style.display = "block";
      viewMobileDeliveries.style.display = "none";
      pinPointBannerPdp.style.display = "block";
      pinPointBanner.style.display = "block";
      shippingMethods.style.display = "block";
      shippingMethodsNotSet.style.display = "none";
      addressSet.style.display = "block";
      addressNotSet.style.display = "none";
      subAddress.innerHTML = selectedAddress;
      mainAddress.innerHTML = "";
      editableId = selectedAddressIdData;
      (addressTitleText.innerText = ADD_ADDRESS),
        (mapTitle.innerText = ADD_ADDRESS);
      isUserSelectAddress = true
      selectedLatLong = {}
      const firstCard = document.getElementById("card_0")
      postalCode = firstCard.getAttribute("data-custom-zip")
      subdistrict = firstCard.getAttribute("data-custom-address2").split(',')[0]
      district = firstCard.getAttribute("data-custom-address2").split(',')[1]
      province = firstCard.getAttribute("data-custom-province")
      sendLatLong(null)
    }
  } else {
    const addressTitle = document.querySelector(".delivery_time-text-title");
    addressTitle.innerText = NO_PINPOINT_LABEL;
  }
}

window.getShippingCalculated = sendLatLong
async function sendLatLong(currentLocationData, currentVariant = null) {
  apiFailed = false;
  if (isUserSelectAddress) {
    try {
      const subDistrictResponse = await subDistrictApiCall();
      if (subDistrictResponse.ok) {
        const subDistrictData = await subDistrictResponse.json();
        const xShippingData = subDistrictData?.data?.sources[0] || []
        const payload = {
          customerId: customerIdData,
          cityDestination: xShippingData?.city?.name || city,
          postalCodeDestination: xShippingData?.postalCode || postalCode,
          orderTimePlaced: new Date(),
          weightInKg:currentVariant ? currentVariant.weight / 1000 : productWeightData / 1000,
          orderItemQuantity: 1,
          productPrice:currentVariant ? currentVariant.price / 100 : productPriceData / 100,
          categoryCodes: ["UNCATEGORY"],
          geolocationExist: true,
          skuProduct: currentVariant ? currentVariant.sku : productSkuData,
          orderStatus: "C",
          provinceDestination: currentLocationData?.currentProvince
            ? currentLocationData.currentProvince
            : province,
          productType: "Regular",
          geoLocationDataDestination: currentLocationData?.currentPosition
            ? currentLocationData.currentPosition
            : { latitude: selectedLatLong.lat, longitude: selectedLatLong.lng },
          ...preOrderData.preOrder && { ...preOrderData },
          emailId: customerEmail,
          recipientDistrict: xShippingData?.district?.name || district,
          recipientSubDistrict:xShippingData?.subDistrict?.name || subdistrict,
          merchantBadge: null,
          officialStore: null,
          dimensionRequest: {
            length: null,
            width: null,
            height: null,
          },
        };
        try {
          const shippingResponse = await fetch(
            `https://${env}/hello-gateway/hello-api/api/shipping`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Shopify-Hmac-Sha256": keyMessage.toString(),
                "X-Shopify-Shop-Domain": domainData.toString(),
              },
              body: JSON.stringify(payload),
            }
          );
          const shippingData = await shippingResponse.json();
          instructionsData = shippingData.value.shippingMethodResponseList
          if (isB2B.getAttribute('data-customer-b2b') === 'true') {
            instructionsData = instructionsData.filter(item => item.type !== 'Instant')
          }
          instructionData();
          let typesArray = [];
          const addressTitle = document.querySelector(".delivery_time-text-title");

          if (instructionsData) {
            typesArray = instructionsData.filter((method) => method.applicable);
          } else {
            addressTitle.innerText = NO_PINPOINT_LABEL;
          }

          if (typesArray.length >= 0) {
            addressTitle.innerText = NO_PINPOINT_LABEL;
          }

          updateAddressDisplay();
          addAddressLabels(typesArray);
        } catch (error) {
          apiFailed = true;
          addressTitle.innerText = NO_PINPOINT_LABEL;
          showErrorModal();
        }
      }
    } catch (error) {
      apiFailed = true;
      addressTitle.innerText = NO_PINPOINT_LABEL;
      showErrorModal();
    }
  }
}

function instructionData() {
  const instructionDiv = document.getElementById("instruction");
  instructionDiv.innerHTML = "";
  instructionDiv.style.overflow = "auto";
  const title = document.createElement("div");
  title.innerText = INSTRUCTION_MODAL_HEADING;
  title.className = "location-header";
  const desc = document.createElement("div");
  desc.className = "location-desc";
  desc.innerText = INSTRUCTION_MODAL_SUBHEADING;
  instructionDiv.appendChild(title);
  instructionDiv.appendChild(desc);

  for (let item = 0; item < instructionsData.length; item++) {
    const divList = document.createElement("div");
    divList.className = "instruction-list";
    const headerDiv = document.createElement("div");
    headerDiv.className = "instruction-header";
    const headerTitle = document.createElement("div");
    headerTitle.className = "header-title";
    const headerTitleLeft = document.createElement("span");
    headerTitleLeft.innerText = instructionsData[item].type;
    headerTitleLeft.className = "header-left";
    const headerTitleRight = document.createElement("span");
    headerTitleRight.className = "header-right";
    headerTitleRight.innerText = shippingDesc(instructionsData[item]);
    headerTitle.appendChild(headerTitleLeft);
    headerTitle.appendChild(headerTitleRight);
    const headerStatus = document.createElement("div");
    headerStatus.className = "header-status";
    headerStatus.innerText = instructionsData[item].applicable
  ? (preOrderData?.preOrder && FREE) || convertToRupiah(instructionsData[item].state, false)
  : NOT_APPLICABLE_SUBTEXT;
    const subHeader = document.createElement("div");
    subHeader.className = "subheader";
    subHeader.innerText = instructionsData[item].applicable
      ? formatDeliveryDesc(instructionsData[item])
      : setErrorMessage(instructionsData[item])
    if (!instructionsData[item].applicable) {
      subHeader.style.color = "#D33534";
    }
    headerDiv.appendChild(headerTitle);
    headerDiv.appendChild(headerStatus);
    divList.appendChild(headerDiv);
    divList.appendChild(subHeader);
    instructionDiv.appendChild(divList);
  }
}

function setErrorMessage(shippingMethod) {
  if (shippingMethod.type === INSTANT && !selectedLatLong.lat && !selectedLatLong.lng) {
    return NOT_APPLICABLE;
  }
  return shippingMethod.errorMessage;
}
function addAddressLabels(typesArray) {
  const instructionDiv = document.querySelector(".shipping-instruction");
  if (labelDiv && typesArray.length > 0) {
    labelDiv.innerText = ADDRESS_LABEL_HEADER;
    const addressTitle = document.querySelector(".delivery_time-text-title");
    addressTitle.innerText = `${ADDRESS_CHEAPEST_PRICE_HEADER} ${typesArray[0].state === 0 ? FREE : convertToRupiah(typesArray[0].state, false)}`;
    instructionDiv.innerText = formatDeliveryDesc(typesArray[0]);
    instructionDiv.style.display = "block";
    for (let i = 0; i < typesArray.length; i++) {
      if (typesArray[i].type) {
        const label = document.createElement("span");
        label.className = "applicable-shipping-methods-label";
        label.innerHTML = typesArray[i].type;
        labelDiv.appendChild(label);
      }
    }
    notCoveredBanner.style.display = "none";
  }
  if (labelDivMobile && typesArray.length > 0) {
    viewMobileDeliveries.style.display = "block";
    viewMobileDeliveriesText.style.display = "none";
    labelDivMobile.innerText = ADDRESS_LABEL_HEADER;
    const addressTitle = document.querySelector(".delivery_time-text-title");
    addressTitle.innerText = `${ADDRESS_CHEAPEST_PRICE_HEADER} ${typesArray[0].state === 0 ? FREE : convertToRupiah(typesArray[0].state, false)}`;
    instructionDiv.innerText = formatDeliveryDesc(typesArray[0]);
    instructionDiv.style.display = "block";
    for (let i = 0; i < typesArray.length; i++) {
      const label = document.createElement("span");
      label.className = "applicable-shipping-methods-label";
      label.innerHTML = typesArray[i].type;
      labelDivMobile.appendChild(label);
    }
    notCoveredBanner.style.display = "none";
  }

  if (typesArray.length <= 0) {
    notCoveredBanner.style.display = "flex";
    viewMobileDeliveries.style.display = "none";
    viewMobileDeliveriesText.style.display = "none";
    const instructionDiv = document.querySelector(".shipping-instruction");
    instructionDiv.style.display = "none";
    labelDiv.innerText = "";
    labelDivMobile.innerHTML = "";
    (addressSet.style.display = "none"), (addressNotSet.style.display = "none");
  }
}

updateAddressDisplay();

window.onload = function () {
  selectAddressCard();
};

function selectAddressCard() {
  let addressCards = document.getElementById("address-grp").children;
  let activeAddressCard = null;

  function resetAddressCards() {
    if (activeAddressCard) {
      activeAddressCard.classList.remove("address-grp-container-active");
    }
  }

  function activateAddressCard(card) {
    resetAddressCards();
    card.classList.add("address-grp-container-active");
    activeAddressCard = card;
  }

  if (addressCards.length > 0) {
    activateAddressCard(addressCards[0]);
  }

  for (let i = 0; i < addressCards.length; i++) {
    addressCards[i].addEventListener("click", function () {
      if (this.id.includes("address-grp_")) {
        activateAddressCard(this);
      }
    });
  }
}

mapSubmitButton.addEventListener("click", () => {
  if (Object.keys(savedAddressData).length !== 0) {
    populateAddressField();
  }
  const input = document.querySelector(
    ".customer-location__address-search__input-1"
  );
  unList1.innerHTML = "";
  input.value = "";
  clearIconInput1.style.display = "none";
  document.querySelector(
    ".customer-location__address-container__location"
  ).style.display = "none";
});

function populateAddressField(name, phone) {
  let parentDivList = document.querySelector(".area-select-options");
  areaFullAddressField.disabled = true;
  if (savedAddressData) {
    pinPointAddress.innerHTML = savedAddressData.addressName
      ? savedAddressData.addressName
      : savedAddressData.fullAddress.split(",")[0];
    areaFullAddressField.value = savedAddressData.fullAddress
      ? savedAddressData.fullAddress
      : "";

    if (name) {
      nameField.value = name;
      phoneField.value = phone;
    }

    if (state === DEFAULT_STATE) {
      areaField.disabled = false;
      getSubDistrictsKeyword();
      showToast({
        message: ADDRESS_ADDED_TOAST_MESSAGE,
        width: "600px",
      });
    } else {
      parentDivList.innerHTML = "";
      areaField.disabled = true;
    }
  }
}

function replaceAndLowerCase(val) {
  return val.toLowerCase().replace(/\s/g, "");
}

async function getSubDistrictsKeyword() {
  apiFailed = false;
  try {
    const response = await subDistrictApiCall()
    splittedCode = await response.json();
    if (response.ok && splittedCode?.data?.sources?.length) {
      addressProvince = splittedCode.data.sources[0].province.name;
      splittedCode = splittedCode.data.sources[0].subDistrict.code.split("-");
      getSubDistricts();
    }
  } catch (error) {
    apiFailed = true;
    showErrorModal();
  }
}
async function getSubDistricts() {
  apiFailed = false;
  try {
    const countryId = splittedCode[0];
    const provinceId = splittedCode[1];
    const cityId = splittedCode[2];
    const districtId = splittedCode[3];
    const response = await fetch(
      `https://${env}/hello-gateway/hello-api/api/address-book/get/subDistrict/${countryId}/${provinceId}/${cityId}/${districtId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Hmac-Sha256": keyMessage.toString(),
          "X-Shopify-Shop-Domain": domainData.toString(),
        },
        body: JSON.stringify({ customerId: customerIdData }),
      }
    );
    const responseData = await response.json();
    subDistrictsList = responseData.data;
    handleAppendAreaOptions();
  } catch {
    apiFailed = true;
    showErrorModal();
  }
}
function handleAppendAreaOptions() {
  let dropdownData = [];
  subDistrictsList.forEach(({ name, postalCode }) => {
    dropdownData.push({
      state,
      city,
      district,
      postalCode,
      subdistrict: name,
    });
  });
  let parentDivList = document.querySelector(".area-select-options");
  parentDivList.innerHTML = "";
  for (let i = 0; i < dropdownData.length; i++) {
    let areaList = document.createElement("li");
    areaList.innerText = `${dropdownData[i].state}, ${dropdownData[i].city}, ${dropdownData[i].district}, ${dropdownData[i].subdistrict}, ${dropdownData[i].postalCode}`;
    parentDivList.appendChild(areaList);
  }
  areaField.value = addressStateFormatted();
  if (dropdownData.length <= 0) {
    areaField.disabled = true;
  } else {
    areaField.disabled = false;
  }
}

customSelectArea.addEventListener("focusin", () => {
  if (customSelectOptionsContainer.children.length > 0) {
    customSelectOptionsContainer.style.display = "block";
  }
});

customSelectOptionsContainer.addEventListener("click", function (event) {
  const clickedElement = event.target;
  if (clickedElement.tagName === "LI") {
    areaField.value = clickedElement.textContent;
    customSelectOptionsContainer.style.display = "none";
  }
});

const addressFormSubmit = document.querySelector(".address-submit");

addressFormSubmit.addEventListener("click", function (event) {
  event.preventDefault();
  if (
    isInputFieldNotEmpty("area-select") &&
    isInputFieldNotEmpty("alamat-select") &&
    isInputFieldNotEmpty("name-select") &&
    isInputFieldNotEmpty("phone-select") &&
    isPhoneValid("phone-select") &&
    isPhoneNumeric("phone-select")
  ) {
    createAddress();
    const confirmModal = document.getElementById("confirm-modal-btn");
    if (confirmModal) {
      const confirmModalOpener = confirmModal.querySelector("button");
      if (confirmModalOpener) {
        confirmModalOpener.click();
      }
    }
    const confirmModalAddress = document.querySelector(
      ".confirmModal-body-address"
    );
    const confirmModalName = document.querySelector(".confirmModal-body-name");
    confirmModalAddress.innerHTML = areaFullAddressField.value;
    confirmModalName.innerHTML = nameField.value;
  } else {
    showErrorMessage(
      "area-select",
      ".error-warning-area-text",
      ".error-warning-area-icon"
    );
    showErrorMessage(
      "alamat-select",
      ".error-warning-alamat-text",
      ".error-warning-alamat-icon"
    );
    showErrorMessage(
      "name-select",
      ".error-warning-name-text",
      ".error-warning-name-icon"
    );
    showErrorMessage(
      "phone-select",
      ".error-warning-phone-text",
      ".error-warning-phone-icon"
    );
  }
});

function isInputFieldNotEmpty(inputId) {
  let inputField = document.getElementById(inputId);
  return inputField.value.trim() !== "";
}
function isPhoneValid(inputId) {
  let inputField = document.getElementById(inputId);
  return inputField.value.length >= 8 ? true : false;
}

function isPhoneNumeric(inputId) {
  let inputField = document.getElementById(inputId);
  return /^\d+$/.test(inputField.value) ? true : false;
}

let areaInput = document.getElementById("area-select");
let alamatInput = document.getElementById("alamat-select");
let nameInput = document.getElementById("name-select");
let phoneInput = document.getElementById("phone-select");

areaInput.addEventListener("input", function () {
  hideErrorMessage(
    "area-select",
    ".error-warning-area-text",
    ".error-warning-area-icon"
  );
});

alamatInput.addEventListener("input", function () {
  hideErrorMessage(
    "alamat-select",
    ".error-warning-alamat-text",
    ".error-warning-alamat-icon"
  );
});

nameInput.addEventListener("input", function () {
  hideErrorMessage(
    "name-select",
    ".error-warning-name-text",
    ".error-warning-name-icon"
  );
});

phoneInput.addEventListener("input", function () {
  hideErrorMessage(
    "phone-select",
    ".error-warning-phone-text",
    ".error-warning-phone-icon"
  );
});

function showErrorMessage(inputId, errorMessageTextId, errorMessageIconId) {
  let inputField = document.getElementById(inputId);
  let errorMessage = document.querySelector(errorMessageTextId);
  let errorMessageIcon = document.querySelector(errorMessageIconId);

  if (!inputField.value.trim()) {
    errorMessage.innerText = EMPTY_TEXT_VALIDATION;
    errorMessage.style.display = "block";
    errorMessageIcon.style.display = "block";
  } else {
    errorMessage.style.display = "none";
    errorMessageIcon.style.display = "none";
    if (inputId === "phone-select" && inputField.value.length < 8) {
      errorMessage.style.display = "block";
      errorMessage.innerText = PHONE_VALIDATION_TEXT_CHAR_LIMIT;
      errorMessageIcon.style.display = "block";
    } else if (inputId === "phone-select" && !/^\d+$/.test(inputField.value)) {
      errorMessage.style.display = "block";
      errorMessage.innerText = PHONE_NUMBER_VALIDATION_ISNUMBER_TEXT;
      errorMessageIcon.style.display = "block";
    }
  }
}

function hideErrorMessage(inputId, errorMessageTextId, errorMessageIconId) {
  let errorMessage = document.querySelector(errorMessageTextId);
  let errorMessageIcon = document.querySelector(errorMessageIconId);

  errorMessage.style.display = "none";
  errorMessageIcon.style.display = "none";
}

const reloadBtn = document.querySelector(".errorModal-footer-reload");
reloadBtn.addEventListener("click", () => {
  window.location.reload();
});

document.addEventListener("DOMContentLoaded", function () {
  hexToBase64(hexHmac);
  const addressGrpContainer = document.getElementById("address-grp");

  if (addressGrpContainer) {
    addressGrpContainer.addEventListener("click", function (event) {
      const clickedElement = event.target;

      if (clickedElement.id === "edit-saved-address") {
        const parentContainer = clickedElement.closest(
          ".address-grp-container"
        );
        let ubahLatLong = JSON.parse(
          parentContainer.getAttribute("data-custom-more-address-position")
        );
        let name = parentContainer.querySelector(
          ".address-grp-header-left"
        ).textContent;
        let phone =
          parentContainer.querySelector(".address-grp-phone").textContent;

        if (ubahLatLong.lat !== 0.0) {
          getGeolocationDetail(ubahLatLong, false, null, "edit", null, null, {
            name: name,
            phone: phone,
          });
        }
        if (parentContainer) {
          const dataId = parentContainer.getAttribute("data-custom-grp-id");
          editableUbahId = dataId;
          editableUbah = true;
          (addressTitleText.innerText = EDIT_ADDRESS),
            (mapTitle.innerText = EDIT_ADDRESS);
        }
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const mapModalClose = document.getElementById(
    "ModalClose-custom-address-close"
  );
  mapModalClose.addEventListener("click", () => {
    editableUbah = false;
    editableUbahId = "";
    (addressTitleText.innerText = ADD_ADDRESS),
      (mapTitle.innerText = ADD_ADDRESS);
    document.querySelector(
      ".customer-location__address-container__location"
    ).style.display = "none";
  });

  const addressModalClose = document.getElementById(
    "ModalClose-addAddress-close"
  );
  addressModalClose.addEventListener("click", () => {
    editableUbah = false;
    editableUbahId = "";
    (addressTitleText.innerText = ADD_ADDRESS),
      (mapTitle.innerText = ADD_ADDRESS);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let searchInput = document.querySelector(".saved__address-search__input");

  searchInput.addEventListener("input", function () {
    let searchTerm = this.value.toLowerCase();
    let addressContainers = document.querySelectorAll(".address-grp-container");

    addressContainers.forEach(function (container) {
      let addressName = container
        .querySelector(".address-grp-main_address")
        .innerText.toLowerCase();

      if (addressName.includes(searchTerm)) {
        container.style.display = "block";
      } else {
        container.style.display = "none";
      }
    });
  });
});

function createAddress() {
  const mainAddressCheckBox = document.getElementById("main-address-checkbox");

  let nameSplitted = nameField.value.split(" ");
  let firstName = nameSplitted[0];
  let lastName = nameSplitted.slice(1).join(" ");

  addAddressData = {
    customerId: customerIdData,
    address: {
      address1: areaFullAddressField.value,
      address2:
        pinPointAddress.innerText === PINPOINT_HEADER
          ? ""
          : pinPointAddress.innerText,
      city: areaField?.value?.split(",")[1] || savedAddressData.city,
      company:
        savedAddressData.latLong.latitude.toString().trim() +
        "," +
        savedAddressData.latLong.longitude.toString().trim(),
      first_name: firstName,
      last_name: lastName || "",
      phone: phoneField.value,
      province: addressProvince.includes(JAKARTA) ? JAKARTA : addressProvince,
      country: savedAddressData.state,
      zip: areaField.value.split(",")[4],
      name: firstName + " " + lastName,
      default: mainAddressCheckBox.checked ? true : false,
    },
  };
  editAddressData = {
    ...addAddressData,
    addressId: editableUbah ? editableUbahId : editableId,
  };
}

document.addEventListener("DOMContentLoaded", function () {
  const confirmSubmit = document.querySelector(".footer-simpan");
  const confrimFooter = document.querySelector(".confirmModal-footer");
  if (confirmSubmit) {
    confirmSubmit.addEventListener("click", () => {
      if (editable || editableUbah) {
        editAddress();
      } else {
        addAddress();
      }
      confrimFooter.style.pointerEvents = "none";
      setTimeout(() => {
        window.location.reload();
      }, 350);
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const bannerBtn = document.querySelector(".banner-btn");
  if (bannerBtn) {
    bannerBtn.addEventListener("click", () => {
      editable = true;
      (addressTitleText.innerText = EDIT_ADDRESS),
        (mapTitle.innerText = EDIT_ADDRESS);
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const bannerBtnPdp = document.querySelector(".banner-btn-pdp");
  if (bannerBtnPdp) {
    bannerBtnPdp.addEventListener("click", () => {
      editable = true;
      (addressTitleText.innerText = EDIT_ADDRESS),
        (mapTitle.innerText = EDIT_ADDRESS);
    });
  }
});

async function addAddress() {
  apiFailed = false;
  try {
    const addressApi = await fetch(
      `https://${env}/hello-gateway/hello-api/api/address-book/insert`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Hmac-Sha256": keyMessage.toString(),
          "X-Shopify-Shop-Domain": domainData.toString(),
        },
        body: JSON.stringify(addAddressData),
      }
    );
    showToast({
      message: ADDRESS_ADDED_SUCCESS_TOAST,
    });
  } catch {
    apiFailed = true;
    showErrorModal();
  }
}

async function editAddress() {
  apiFailed = false;
  try {
    const addressApi = await fetch(
      `https://${env}/hello-gateway/hello-api/api/address-book/update`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Hmac-Sha256": keyMessage.toString(),
          "X-Shopify-Shop-Domain": domainData.toString(),
        },
        body: JSON.stringify(editAddressData),
      }
    );
    showToast({
      message: ADDRESS_ADDED_SUCCESS_TOAST,
    });
  } catch {
    apiFailed = true;
    showErrorModal();
  }
}

function hexToBase64(hex) {
  const byteArr = hex.match(/.{1,2}/g).map((byte) => parseInt(byte, 16));
  const base64 = btoa(String.fromCharCode.apply(null, byteArr));
  keyMessage = base64;
}

editLocation.addEventListener("click", () => {
  map.setCenter({
    lat: savedAddressData.latLong.latitude,
    lng: savedAddressData.latLong.longitude,
  });
  dragEndListener();
});

notloggedInOpener.addEventListener("click", () => {
  if (apiFailed) {
    notloggedInOpener.dataset.modal = "#PopupModal-errorModal";
    showErrorModal();
  }
});
instructionModalBtn.addEventListener("click", () => {
  if (apiFailed) {
    instructionModalBtn.dataset.modal = "#PopupModal-errorModal";
    showErrorModal();
  }
});
viewMobileDeliveriesText.addEventListener("click", () => {
  if (apiFailed) {
    viewMobileDeliveriesText.dataset.modal = "#PopupModal-errorModal";
    showErrorModal();
  }
});

function showErrorModal() {
  const errorTrigger = document.querySelector("#errorTrigger button");
  if (errorTrigger) {
    errorTrigger.click();
  }
}

function shippingDesc({ type, etdCountFrom, etdCountTo }) {
  if (type === INSTANT) return INSTANT_DESC;
  if (type === SAME_DAY) return SAME_DAY_DESC;
  const formatDays = (from, to) => from === to ? `${from === 0 ? 1 : from} hari` : `${from} - ${to} hari`;
  if (preOrderData?.preOrder) {
    const noOfDaysBetween = countDaysBetween(new Date(), formatDataSpliteTime(preOrderData.preOrderDate));
    const preOrderEtdCountFrom = Math.max(0, etdCountFrom - noOfDaysBetween)
    const preOrderEtdCountTo = Math.max(0, etdCountTo - noOfDaysBetween)
    return formatDays(preOrderEtdCountFrom, preOrderEtdCountTo)
  }
  return formatDays(etdCountFrom, etdCountTo);
}

function formatDeliveryDesc({ type, etdCountFrom, etdCountTo }) {
  const isPreOrder = preOrderData?.preOrder;
  if (type === INSTANT || type === SAME_DAY) {
    return isPreOrder 
      ? `Estimasi tiba ${formatPreOrderDate(preOrderData.preOrderDate)}`
      : "Sampai hari ini";
  }
  if (isPreOrder) {
    return formatEtdRange(etdCountFrom, etdCountTo);
  }
  return formatDateToDayName(etdCountTo === 0 ? 1 : etdCountTo);
}

function formatPreOrderDate(preOrderDate) {
  return formatDateToShortMonth(new Date(preOrderDate));
}

function formatEtdRange(from, to) {
  const fromDate = addDays(new Date(), from);
  const toDate = addDays(new Date(), to);
  return from === to 
    ? `Estimasi tiba ${formatDateToShortMonth(toDate)}`
    : `Estimasi tiba ${formatDateToShortMonth(fromDate)} - ${formatDateToShortMonth(toDate)}`;
}

function addDays(date, days) {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
}

function formatDateToShortMonth(date) {
  return new Date(date).toLocaleDateString('id-ID', { day: 'numeric', month: 'short' });
}

function addressStateFormatted() {
  return (
    state +
    ", " +
    city +
    ", " +
    district +
    ", " +
    subdistrict +
    ", " +
    postalCode
  );
}

initGoogle();

function subDistrictApiCall() {
  return fetch(
    `https://${env}/hello-gateway/hello-api/api/address-book/search/subDistrict?postalCode=${postalCode}&search=${replaceAndLowerCase(
      subdistrict
    )}&district=${replaceAndLowerCase(district)}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Hmac-Sha256": keyMessage.toString(),
        "X-Shopify-Shop-Domain": domainData.toString(),
      },
      body: JSON.stringify({ customerId: customerIdData }),
    }
  )
}

function formatDateToDayName(noOfDays) {
  const date = new Date();
  date.setDate(date.getDate() + noOfDays);
  const options = { weekday: "long", day: "numeric", month: "long" };
  const formattedDate = new Intl.DateTimeFormat("id-ID", options).format(date);
  return `Sampai pada ${formattedDate}`;
}

function formatDataSpliteTime(date){
  return new Date(date.split("T")[0]);
}

function countDaysBetween(date1, date2) {
  const oneDayInMs = 24 * 60 * 60 * 1000;
  const date1Ms = new Date(date1).getTime();
  const date2Ms = new Date(date2).getTime();
  const diffInMs = Math.abs(date2Ms - date1Ms);
  return Math.ceil(diffInMs / oneDayInMs);
}

function getPreOrderData() {      
  if (preOrderTagData) {
    const [_, dateString] = preOrderTagData.split("@");
    const dateFormat = new Date(
      parseInt(dateString.substring(4, 8)),
      parseInt(dateString.substring(2, 4)) - 1,
      parseInt(dateString.substring(0, 2))
    )
    dateFormat.setDate(dateFormat.getDate())  
    return {
      preOrder: true,
      preOrderType: "DATE",
      preOrderValue: null,
      preOrderDate: dateFormat.toISOString(),
    }
  } else {
      return {
        preOrder: false,
        preOrderType: null,
        preOrderValue: null,
        preOrderDate: null,
      }
    }
}
